import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { v4 as uuidv4 } from 'uuid';
import { Button, IconButton } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

import Rule from './Rule';

import DeleteIcon from '@material-ui/icons/Delete';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withSearchTree from './hoc/WithSearchTree';

const MAX_DEPTH = 4;
const MAX_RULES = 50;

class Group extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        tree: PropTypes.object.isRequired,
        depth: PropTypes.number.isRequired,
        fields: PropTypes.object.isRequired,
        // HOC - WithSearchTree
        onBranch: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
        onAddRule: PropTypes.func.isRequired,
        onAddGroup: PropTypes.func.isRequired,
        onConjunctionChange: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {
            classes,
            tree,
            fields,
            depth,
            onBranch,
            onAddRule,
            onAddGroup,
            onConjunctionChange,
            onDelete
        } = this.props;

        const rootRules = tree.children.filter(child => child.type === 'rule');
        const requiredRulePresent = rootRules.filter(
            child => fields[child.field]?.isRequired && child.id.includes('required')
        );

        const isOrVisible = !(requiredRulePresent.length > 0 && depth === 0);

        return (
            <div className={classes.root}>
                <div className={classes.heading}>
                    <ToggleButtonGroup
                        classes={{
                            root: classes.toggleButtonGroupRoot,
                            grouped: classes.toggleButtonGroupGrouped
                        }}
                        exclusive
                        value={tree.conjunction}
                        onChange={onConjunctionChange}>
                        <ToggleButton value="and">AND</ToggleButton>

                        {isOrVisible && <ToggleButton value="or">OR</ToggleButton>}
                    </ToggleButtonGroup>
                    {tree.children.length < MAX_RULES && (
                        <Button onClick={onAddRule}>ADD RULE</Button>
                    )}
                    {depth < MAX_DEPTH && tree.children.length < MAX_RULES && (
                        <Button onClick={onAddGroup}>ADD GROUP</Button>
                    )}
                    <IconButton
                        size="small"
                        aria-label="Delete Group"
                        onClick={onDelete}>
                        <DeleteIcon />
                    </IconButton>
                </div>
                <div className={classes.children}>
                    {tree.children && tree.children.map(onBranch)}
                </div>
            </div>
        );
    }
}

const style = theme => ({
    root: {
        width: '100%',
        backgroundColor: `${theme.palette.secondary.light}33`,
        border: `1px solid ${theme.palette.secondary.light}`,
        borderRadius: '5px',
        padding: 10,
        boxSizing: 'border-box'
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    toggleButtonGroupRoot: {
        marginRight: 'auto'
    },
    toggleButtonGroupGrouped: {
        padding: 5
    },
    // Set last value for 10 for arrows along vertical left side
    children: {
        padding: '0px 0px 0px 0px',
        '&> *:not(:last-child)': {
            marginBottom: 10
        },
        '&> *:first-child': {
            marginTop: 10
        }
    }
});

export default compose(withStyles(style), withSearchTree)(Group);
